(() => {

  'use strict';

  if (window.smCartRewards) return;

  window.smCartRewards = true;

  const root = () => document.querySelector('#cart-drawer.sm-cart');

  const routes = () => window.Shopify?.routes?.root || '/';

  const previewTheme = () => new URL(location.href).searchParams.get('preview_theme_id') || root()?.dataset.smPreviewTheme;

  let busy = false, writing = false, refreshing = null, requested = false, epoch = 0;

  let nativeTimer;
  let railOffset=0;
  function carousel(drawer) {
    const rail=drawer?.querySelector('[data-sm-rail]');
    if(!rail)return;
    const cards=[...rail.querySelectorAll('.sm-cart-offer')],max=rail.scrollWidth-rail.clientWidth;
    const position=cards.length ? Math.min(cards.length,Math.round(rail.scrollLeft/(cards[0].getBoundingClientRect().width+10))+1) : 0;
    const previous=drawer.querySelector('[data-sm-scroll="-1"]'),next=drawer.querySelector('[data-sm-scroll="1"]');
    if(previous)previous.disabled=rail.scrollLeft<2;
    if(next)next.disabled=rail.scrollLeft>=max-2;
    const count=drawer.querySelector('[data-sm-carousel-position]');if(count)count.textContent=position+' / '+cards.length;
  }
  document.addEventListener('scroll',event=>{
    if(event.target?.matches?.('[data-sm-rail]') && root()?.contains(event.target)) {railOffset=event.target.scrollLeft;carousel(root());}
  },true);

  function recoverMarketCurrency(currency) {
    // This key contains only our recovery target and time, never buyer data.
    const key='sm-cart-currency-recovery';
    try {
      const previous=JSON.parse(sessionStorage.getItem(key) || 'null');
      if (previous && previous.path===location.pathname && previous.currency===currency && Date.now()-previous.at<120000) {
        throw new Error('Recovery already attempted');
      }
      sessionStorage.setItem(key,JSON.stringify({path:location.pathname,currency,at:Date.now()}));
    } catch(e) {throw new Error('Your market changed. Refresh for current prices.');}
    // Keep the entire storefront in one currency, including restored headers
    // and product prices. Preserve the exact locale and preview URL.
    location.reload();
  }

  function lock(drawer, value) {

    if (!drawer) return;

    drawer.setAttribute('aria-busy', String(value));

    drawer.querySelectorAll('[data-sm-add],[data-sm-quantity],[name="checkout"],[data-sm-device]').forEach(b => {

      b.disabled = value || (b.hasAttribute('data-sm-add') && !b.dataset.smAdd);

    });

  }

  function error(drawer, message) {

    const node = drawer?.querySelector('.sm-cart-error');

    if (!node) return;

    node.hidden = false; node.textContent = message + ' ';

    const refresh = document.createElement('button');

    refresh.type = 'button'; refresh.textContent = 'Refresh cart'; refresh.dataset.smRefresh = '';

    refresh.style.textDecoration = 'underline'; node.append(refresh);

  }

  async function sectionHTML(drawer) {

    const url = new URL(location.href);

    url.searchParams.set('sections', drawer.dataset.smSection);

    if (previewTheme()) url.searchParams.set('preview_theme_id', previewTheme());

    const response = await fetch(url.pathname + url.search, {cache:'no-store'});

    if (!response.ok) throw new Error('Refresh the cart to check your total.');

    const sections = await response.json();

    const html = sections[drawer.dataset.smSection];

    const content = html && new DOMParser().parseFromString(html,'text/html').querySelector('#cart-drawer.sm-cart');

    if (!content || !content.dataset.smCurrency || (previewTheme() && content.dataset.smPreviewTheme !== previewTheme())) throw new Error('Refresh the cart to check your total.');

    return {html, currency:content.dataset.smCurrency};

  }

  function renderCart(drawer, cart) {

    return new Promise((resolve, reject) => {

      const inner = drawer.querySelector('.cart-drawer__inner');

      const observer = new MutationObserver(records => {

        if (records.some(r => r.target === inner || r.target === drawer)) {

          observer.disconnect(); clearTimeout(timer); resolve();

        }

      });

      const timer = setTimeout(() => {observer.disconnect(); reject(new Error('Refresh the cart to check your total.'));},3000);

      observer.observe(drawer,{childList:true,subtree:true});

      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{cart,baseEvent:'variant:add',smRewardsInternal:true}}));

    });

  }

  function reconcile() {

    requested = true;

    if (writing) return Promise.resolve();

    if (refreshing) return refreshing;

    refreshing = (async () => {

      let failed = false, latest;

      busy = true; lock(root(),true);

      try {

        while (requested) {

          requested = false;

          const version = epoch, drawer = root();

          if (!drawer) throw new Error('Refresh the page to restore your cart.');

          // Re-render for the current country route first. A restored page can
          // contain the old currency after checkout changes the buyer country.
          // Never unlock controls until both fresh server responses agree.
          let section, cart, matched=false;
          for (let attempt=0; attempt<2; attempt++) {
            section = await sectionHTML(drawer);
            const response = await fetch(routes()+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
            if (!response.ok) throw new Error('Refresh the cart to check your total.');
            cart = await response.json();
            if (cart.currency === section.currency) {matched=true;break;}
          }
          if (!matched) throw new Error('Your market changed. Refresh for current prices.');
          if (version !== epoch || writing) {requested=true; continue;}
          // Native rendering keeps the custom element, so update its currency
          // only after validating fresh markup, preview identity and cart data.
          if (drawer.dataset.smCurrency !== cart.currency) {
            failed=true; // Keep stale controls locked while the page reloads.
            recoverMarketCurrency(cart.currency);
            return;
          }
          cart.sections = {[drawer.dataset.smSection]:section.html};

          const wasUnlocked=drawer.querySelector('[data-sm-unlocked]')?.dataset.smUnlocked==='true';
          await renderCart(drawer,cart);
          try {sessionStorage.removeItem('sm-cart-currency-recovery');} catch(e) {}
          const rail=drawer.querySelector('[data-sm-rail]');if(rail)rail.scrollLeft=railOffset;
          carousel(drawer);
          const reward=drawer.querySelector('[data-sm-unlocked]');
          if(reward && !wasUnlocked && reward.dataset.smUnlocked==='true')reward.classList.add('sm-cart-celebrate');

          latest=cart;

          if (version !== epoch) requested=true;

        }

        return latest;

      } catch(e) {failed=true; error(root(),e.message || 'Refresh the cart before trying again.');}

      finally {refreshing=null;busy=failed || writing;lock(root(),busy);}

    })();

    return refreshing;

  }

  document.addEventListener('cart:change', event => {

    if (!root() || event.detail?.smRewardsInternal) return;

    event.stopImmediatePropagation(); clearTimeout(nativeTimer); epoch++;

    reconcile();

  },true);

  document.addEventListener('cart:refresh', event => {

    if (!root()) return;

    event.stopImmediatePropagation(); clearTimeout(nativeTimer); epoch++; reconcile();

  },true);

  document.addEventListener('cart:error', event => {

    if (!root()) return;

    clearTimeout(nativeTimer); epoch++;

    reconcile().then(()=>error(root(),event.detail?.error || 'This item could not be added.'));

  },true);

  async function mutate(drawer, endpoint, payload) {

    if (busy) return;

    writing=true;busy=true;epoch++;lock(drawer,true);

    const focusKey=document.activeElement?.closest('[data-sm-key]')?.dataset.smKey;
    const offerVariant=endpoint==='cart/add.js'?String(payload.items?.[0]?.id || ''):'';

    let result, accepted=false, uncertain=true, message;

    try {

      const response = await fetch(routes()+endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});

      result = await response.json();

      if (!response.ok) {

        uncertain=![400,422].includes(response.status);

        throw new Error(result.description || 'This item could not be updated.');

      }

      accepted=true;uncertain=false;

    } catch(e) {message=e.message || 'Connection interrupted. Refresh before trying again.';}

    finally {writing=false;epoch++;}

    const cart=await reconcile();

    if (message) error(root(),message);

    if (uncertain) {busy=true;lock(root(),true);}

    if (accepted && cart && endpoint==='cart/add.js') {

      root().dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items || [result],cart}}));

    }

    if (cart && offerVariant) {
      const card=[...root().querySelectorAll('[data-sm-offer-id]')].find(x=>x.dataset.smOfferId===offerVariant);
      if(card){card.setAttribute('tabindex','-1');card.focus({preventScroll:true});}
      else root().querySelector('[data-sm-rail]')?.focus({preventScroll:true});
    }
    if (cart && focusKey) {

      const target=[...root().querySelectorAll('[data-sm-key]')].find(x=>x.dataset.smKey===focusKey);

      (target?.querySelector('[data-sm-quantity]') || root().querySelector('button'))?.focus({preventScroll:true});

    }

  }

  document.addEventListener('click',event=>{

    const drawer=root();if(!drawer || !drawer.contains(event.target))return;

    if(event.target.closest('[data-sm-refresh]')){location.reload();return;}

    const scroll=event.target.closest('[data-sm-scroll]');
    if(scroll){const rail=drawer.querySelector('[data-sm-rail]'),card=rail?.querySelector('.sm-cart-offer');if(card)rail.scrollBy({left:Number(scroll.dataset.smScroll)*(card.getBoundingClientRect().width+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});return;}
    const add=event.target.closest('[data-sm-add]'),qty=event.target.closest('[data-sm-quantity]');

    if(!add && !qty)return;

    event.preventDefault();event.stopImmediatePropagation();

    if(add && add.dataset.smAdd)mutate(drawer,'cart/add.js',{items:[{id:Number(add.dataset.smAdd),quantity:1}]});

    else if(qty)mutate(drawer,'cart/change.js',{id:qty.closest('[data-sm-key]').dataset.smKey,quantity:Number(qty.dataset.smQuantity)});

  },true);

  document.addEventListener('change',event=>{

    if(!event.target.matches('[data-sm-device]'))return;

    const card=event.target.closest('[data-sm-device-offer]'),option=event.target.selectedOptions[0],button=card.querySelector('[data-sm-add]');

    const alreadyAdded=option.dataset.added==='true';
    button.dataset.smAdd=alreadyAdded?'':event.target.value;button.disabled=busy || !event.target.value || alreadyAdded;
    button.textContent=alreadyAdded?'Added ✓':'+ Add';button.classList.toggle('is-added',alreadyAdded);

    if(option.dataset.price)card.querySelector('[data-sm-option-price]').textContent=option.dataset.price;

    if(option.dataset.image){const image=card.querySelector('.sm-cart-image img');image.src=option.dataset.image;image.removeAttribute('srcset');}

    if(option.dataset.url)card.querySelector('.sm-cart-image').href=option.dataset.url;

  });

  document.addEventListener('submit',event=>{

    const drawer=root();if(!drawer)return;

    const isAdd=/\/cart\/add/.test(event.target.action || '');

    if(busy && (drawer.contains(event.target)||isAdd)){event.preventDefault();event.stopImmediatePropagation();return;}

    if(isAdd){busy=true;lock(drawer,true);clearTimeout(nativeTimer);nativeTimer=setTimeout(()=>error(root(),'The update is taking longer than expected. Refresh before trying again.'),20000);}

  },true);

  customElements.whenDefined('cart-drawer').then(()=>{

    const drawer=root();if(drawer){drawer._onCartRefresh=()=>{epoch++;return reconcile();};carousel(drawer);}

  });

})();

